module.exports = __webpack_public_path__ + "img/t-1.69431381.jpg";